<template>
  <vue-context ref="menu">
    <ul>
      <li v-if="idParam != null">
        <router-link
          :to="{ name: linkName, params: { id: idParam } }"
          target="_blank"
        >
          {{ $t('message.open_in_new_tab') }}
        </router-link>
      </li>
    </ul>
  </vue-context>
</template>

<script>
import { VueContext } from 'vue-context';

export default {
    name: 'CustomContextMenu',
    components: { VueContext },
    props: {
        visible: {
            type: Boolean
        },
        event: {},
        linkName: {
            type: String
        },
        idParam: {
            type: Number
        }
    },
    watch: {
        visible: function (val) {
            if (val) {
                this.$refs.menu.open(this.event);
            }
        }
    },
    mounted () {
        this.$watch(
            () => {
                return this.$refs.menu.show;
            },
            (val) => {
                this.$emit('show', val);
            }
        );
    }
};
</script>

<style scoped></style>
